import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Button } from "@material-ui/core";
import { useState } from "react";
import { getServerUri } from "../../modules/uriUtility";

const useStyles = makeStyles(() => ({
  root: {},
  drawerPaper: {
    top: "inherit",
    width: "21rem",
    color: "white"
  },
  list: {
    padding: "0"
  },
  listItem: {
    padding: "1rem"
  },
  logoutButtonWrapper: {
    bottom: "0",
    top: "auto",
    position: "fixed",
    width: "21rem",
    textAlign: "center"
  },
  logoutButton: {
    padding: "1.5rem",
    width: "100%"
  }
}));

export default function PermanentDrawerLeft(props) {
  const classes = useStyles();
  const [role, setRole] = useState(props.userRole || "member");

  useEffect(() => {
    setRole(props.userRole || "member");
  }, [props.userRole]);

  // Both admin tiers get the company-scoped screens; only a superAdmin gets the
  // one that reaches across companies.
  const isAdmin = role === "superAdmin" || role === "companyAdmin";
  const isSuperAdmin = role === "superAdmin";

  return (
    <div id="navbarAccountSettings" className={classes.root}>
      <Drawer
        variant="permanent"
        classes={{
          paper: classes.drawerPaper
        }}
        anchor="left"
      >
        <Divider />
        <List id="navbarAccountSettings_list" className={classes.list}>
          <ListItem
            id="navbarAccountSettings_button"
            button
            className={classes.listItem}
            component="a"
            onClick={() => {
              props.setSelectedPage(0);
            }}
          >
            <ListItemText primary="Account Information"></ListItemText>
          </ListItem>
          <Divider />
        </List>
        {isAdmin && (
          <List id="navbarAccountSettings_list2" className={classes.list}>
            <ListItem
              id="navbarAccountSettings_button2"
              button
              className={classes.listItem}
              component="a"
              onClick={() => {
                props.setSelectedPage(1);
              }}
            >
              <ListItemText primary="Billing"></ListItemText>
            </ListItem>
            <Divider />
          </List>
        )}
        {isAdmin && (
          <List id="navbarAccountSettings_list3" className={classes.list}>
            <ListItem
              id="navbarAccountSettings_button3"
              button
              className={classes.listItem}
              component="a"
              onClick={() => {
                props.setSelectedPage(2);
              }}
            >
              <ListItemText primary="User Management"></ListItemText>
            </ListItem>
            <Divider />
          </List>
        )}
        {/*{*/}
        {/*    isAdmin &&*/}
        {/*    <List>*/}
        {/*        <ListItem button*/}
        {/*                  component="a"*/}
        {/*                  onClick={() => {*/}
        {/*                      props.setSelectedPage(3);*/}
        {/*                  }}>*/}
        {/*            <ListItemText primary="Pricing"></ListItemText>*/}
        {/*        </ListItem>*/}
        {/*        <Divider/>*/}
        {/*    </List>*/}
        {/*}*/}
        <List id="navbarAccountSettings_list4" className={classes.list}>
          <ListItem
            id="navbarAccountSettings_button4"
            button
            className={classes.listItem}
            component="a"
            onClick={() => {
              props.setSelectedPage(4);
            }}
          >
            <ListItemText primary="Tools"></ListItemText>
          </ListItem>
          <Divider />
        </List>
        {props.userPermissions && props.userPermissions.transferVersion === true && (
          <List id="navbarAccountSettings_list5" className={classes.list}>
            <ListItem
              id="navbarAccountSettings_button5"
              button
              className={classes.listItem}
              component="a"
              onClick={() => {
                props.setSelectedPage(5);
              }}
            >
              <ListItemText primary="Version Transfer"></ListItemText>
            </ListItem>
            <Divider />
          </List>
        )}
        {props.userPermissions &&
          props.userPermissions.bulkUpdateDatabase === true && (
          <List id="navbarAccountSettings_list6" className={classes.list}>
            <ListItem
              id="navbarAccountSettings_button6"
              button
              className={classes.listItem}
              component="a"
              onClick={() => {
                props.setSelectedPage(6);
              }}
            >
              <ListItemText primary="Version Update"></ListItemText>
            </ListItem>
            <Divider />
          </List>
        )}
        {/* A superAdmin reaches runtime bases and games from Companies & Games;
            anyone else it granted them gets the screen on its own. So does a
            holder of "Grant pe3d games to bases", for its pe3d bases alone. */}
        {!isSuperAdmin && (props.canManageRuntimeBases || props.canGrantPe3dGames) && (
          <List id="navbarAccountSettings_list8" className={classes.list}>
            <ListItem
              id="navbarAccountSettings_button8"
              button
              className={classes.listItem}
              component="a"
              onClick={() => {
                props.setSelectedPage(8);
              }}
            >
              <ListItemText primary={props.canManageRuntimeBases ? "Runtime Bases & Games" : "PE3D Bases"}></ListItemText>
            </ListItem>
            <Divider />
          </List>
        )}
        {/* Likewise the base grant: a superAdmin has it in Companies & Games. */}
        {!isSuperAdmin && props.canGrantBasesToCompanies && (
          <List id="navbarAccountSettings_list9" className={classes.list}>
            <ListItem
              id="navbarAccountSettings_button9"
              button
              className={classes.listItem}
              component="a"
              onClick={() => {
                props.setSelectedPage(9);
              }}
            >
              <ListItemText primary="Companies"></ListItemText>
            </ListItem>
            <Divider />
          </List>
        )}
        {isSuperAdmin && (
          <List id="navbarAccountSettings_list7" className={classes.list}>
            <ListItem
              id="navbarAccountSettings_button7"
              button
              className={classes.listItem}
              component="a"
              onClick={() => {
                props.setSelectedPage(7);
              }}
            >
              <ListItemText primary="Companies & Games"></ListItemText>
            </ListItem>
            <Divider />
            {/* Usage analytics — its own page (src/analytics), opened in a new tab */}
            <ListItem
              id="navbarAccountSettings_buttonAnalytics"
              button
              className={classes.listItem}
              component="a"
              href="/analytics"
              target="_blank"
              rel="noopener"
            >
              <ListItemText primary="Analytics"></ListItemText>
            </ListItem>
            <Divider />
            {/* Monthly reports from the agent container — its own page (src/reports), opened in a new tab */}
            <ListItem
              id="navbarAccountSettings_buttonReports"
              button
              className={classes.listItem}
              component="a"
              href="/reports"
              target="_blank"
              rel="noopener"
            >
              <ListItemText primary="Reports"></ListItemText>
            </ListItem>
            <Divider />
          </List>
        )}
        <div className={classes.logoutButtonWrapper}>
          <Divider />
          <Button
            id="logout_button"
            className={classes.logoutButton}
            color={"primary"}
            onClick={() => {
              props.setIsVersionBeingUpdatedFalse(props.selectedVersion);
              // Retire the token server-side too — clearing localStorage alone
              // left it valid for anyone who had captured it.
              const accessToken = localStorage.getItem("session.accessToken");
              const done = () => {
                localStorage.clear();
                location = "/login";
              };
              fetch(getServerUri("authentication/logout"), {
                method: "POST",
                headers: { "content-type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams({ accessToken }),
              })
                .then(done)
                .catch(done);
            }}
          >
            Logout
          </Button>
          <Divider />
        </div>
      </Drawer>
    </div>
  );
}
